<div class="color-chooser">
  @if (lowContrastColors.size > 0) {
    <div class="disabled-low-contrast-warning">
      <mat-icon svgIcon="contrast-info"></mat-icon>
      {{ 'i18n.control.colorChooser.lowContrastHint' | translate }}
    </div>
  }
  @if (colors.additionalColors.length > 0) {
    <div class="control-box">
      <div class="title">
        {{ 'i18n.control.colorChooser.matchingColors' | translate }}
      </div>
      <div class="colors">
        @for (color of colors.additionalColors; track $index) {
          <div class="color"
            [ngClass]="{
              'active': color === currentColor,
              'low-contrast': lowContrastColors.has(color),
              'dark': darkColors.has(color)
            }"
            [style.backgroundColor]="color"
            (click)="setColor(color)"
            >
            @if (color === currentColor) {
              <mat-icon svgIcon="checkmark"></mat-icon>
            }
          </div>
        }
      </div>
    </div>
  }
  <div class="control-box">
    <div class="title">
      {{ (appliesToBackground
          ? 'i18n.control.colorChooser.allBgColors'
          : 'i18n.control.colorChooser.allColors') | translate }}
    </div>
    <div class="colors">
      @for (color of colors.baseColors; track $index) {
        <div class="color"
          [ngClass]="{
            'active': color === currentColor,
            'low-contrast': lowContrastColors.has(color),
            'dark': darkColors.has(color)
          }"
          [style.backgroundColor]="color"
          (click)="setColor(color)"
          >
          @if (color === 'transparent') {
            <mat-icon svgIcon="close"></mat-icon>
          } @else if (color === currentColor) {
            <mat-icon svgIcon="checkmark"></mat-icon>
          }
        </div>
      }
    </div>
  </div>
</div>
